import { doc, getDoc } from "firebase/firestore/lite";
import { db } from "senf-shared/auth/firebase";
import type { Project, User } from "senf-shared/types";
import i18n from "senf-shared/utils/i18n";

export interface DemographicItem {
  name: string;
  label: string;
  type: string;
  options?: Array<{ label: string; value: string | number }>;
}

export const getYears = (): Array<{ value: number; label: number }> => {
  const thisYear = new Date().getFullYear();
  const max = thisYear - 0;
  const years: Array<{ value: number; label: number }> = [];

  for (let i = max; i >= thisYear - 120; i--) {
    years.push({ value: i, label: i });
  }

  return years;
};

export const getDemographicItems = (project: Project): DemographicItem[] => {
  const defaultItems: Project['settings']['demographicData']['fields'] = []

  if (!project?.settings?.demographicData?.withoutPostcode) {
    defaultItems.push({
      name: "postcode",
      label: i18n.t("global:postcode"),
      type: "text",
    })
  }
  defaultItems.push({
    name: "gender",
    label: i18n.t("global:gender"),
    type: "singlechoice",
    options: [
      { label: i18n.t("global:female"), value: "female" },
      { label: i18n.t("global:male"), value: "male" },
      { label: i18n.t("global:diverse"), value: "diverse" },
      { label: i18n.t("global:preferNotToSay"), value: "preferNotToSay" },
    ],
  },
    { name: "age", label: i18n.t("global:age"), type: "singlechoice" })

  const projectFields = project?.settings?.demographicData?.fields || [];

  const updatedItems = defaultItems.map((item) => {
    const projectField = projectFields.find(
      (field) => field.name === item.name
    );
    return projectField ? { ...item, ...projectField } : item;
  });

  const customFields = projectFields.filter(
    (field) => !defaultItems.some((item) => item.name === field.name)
  );

  return [...updatedItems, ...customFields];
};

export const fetchProjectSpecificData = async (
  project: Project,
  user: User
) => {
  if (project?.settings?.demographicData?.fields && user?.userId) {
    try {
      const participantDoc = await getDoc(
        doc(
          db,
          `organizations/${project.organizationId}/projects/${project.projectId}/participants/${user.userId}`
        )
      );

      if (participantDoc.exists()) {
        return participantDoc.data();
      }
    } catch (error) {
      console.error("Error fetching project-specific participant data:", error);
    }
  }
  return null;
};
